import { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Grid,
  Button,
} from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import { Box } from '@mui/system';
import { Link, useParams } from 'react-router-dom';
import {
  IMoneyReceipt,
  IResponseMoneyReceipt,
} from 'src/Types/module/common/commonTypes';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import PrintMoneyReceipt from './PrintInformationForm/PrintMoneyReceipt';
import { HttpClient } from 'src/Helpers/http/http';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import CommonDateRangePicker from 'src/common/CommonDateRangePicker';
import dayjs from 'dayjs';
import moment from 'moment';
import { Visibility } from '@mui/icons-material';
import DeleteConfirmation from 'src/Utils/DeleteConfirmation';
import Toaster from 'src/Toaster/Toaster';
import { url } from 'src/Helpers/utils/Constant';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import CreateOldMoneyReceipt from '../../moneyReceipt/components/CreateOldMoneyReceipt';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import TransferMoneyReceipt from '../../moneyReceipt/components/TransferMoneyReceipt';
export type TDate = {
  startDate: Date | null;
  endDate: Date | null;
};
const CompanyOldMoneyReceipt = ({ companyName }: { companyName: string }) => {
  const { memberId } = useParams();
  const [memberInvoice, setMemberInvoice] = useState<IMoneyReceipt[]>([]);
  const [loading, setLoading] = useState(false);
  const [moneyReceiptId, setMoneyReceiptId] = useState<number>(0);
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);
  const [open1, setOpen1] = useState<boolean>(false);
  const componentRef = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${memberId}_transaction `,
  });
  const [dateRange, setDateRange] = useState<{
    start_date: string;
    end_date: string;
  }>({
    start_date: '',
    end_date: dayjs().format('YYYY-MM-DD'),
  });

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        let uri = `/api/atab/admin/money-receipt/old?member_id=${memberId}`;
        if (dateRange.start_date && dateRange.end_date) {
          uri += `&from_date=${dateRange.start_date}&to_date=${dateRange.end_date}`;
        }

        const data: IResponseMoneyReceipt = await HttpClient.get(uri);
        if (data.success) {
          setMemberInvoice(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [memberId, dateRange, refresh]);
  const handleDelete = async (id: number) => {
    try {
      setIsDeleteLoading(true);

      // keep consistent with your GET call style if HttpClient is already configured
      const uri = `/api/atab/admin/money-receipt/old/${id}`;
      const data = await HttpClient.delete(uri);

      if (data) {
        setMemberInvoice((prev) => prev.filter((item) => item.id !== id));

        Toaster().fire({ icon: 'success', title: 'Deleted successfully!' });

        setOpen2(false);
        setDeleteId(null);
      }
    } catch (error) {
      // optionally show error toast
      Toaster().fire({ icon: 'error', title: 'Delete failed!' });
    } finally {
      setIsDeleteLoading(false);
    }
  };

  return (
    <Box maxWidth={'100%'}>
      <Box>
        <Grid container justifyContent={'end'} sx={{ paddingBottom: '10px' }}>
          <Grid item xs={6}>
            <CommonDateRangePicker
              setDateRange={setDateRange}
              dateRange={dateRange}
            />
          </Grid>

          <Grid item>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Tooltip title='Print money receipt'>
                <IconButton onClick={handlePrint}>
                  <PrintIcon
                    sx={{
                      cursor: 'pointer',
                      color: theme.colors.primary.main,
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Button
                type='submit'
                variant='contained'
                disableElevation
                fullWidth
                onClick={() => setOpen(true)}
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Money Receipt no</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableLoader />
              ) : (
                <>
                  {memberInvoice?.length ? (
                    <>
                      {memberInvoice.map((details) => (
                        <TableRow hover key={details.id}>
                          <TableCell>
                            {moment(details.created_at).format('DD-MMM-YYYY')}
                          </TableCell>
                          <TableCell>{details.money_receipt_no}</TableCell>
                          <TableCell>
                            {details.user_member_company_name}
                          </TableCell>

                          <TableCell>
                            {details.total_collected_amount}
                          </TableCell>
                          <TableCell>
                            <Tooltip title='View' arrow>
                              <Link
                                to={`/money-receipt/old/list/${details.id}`}
                              >
                                <IconButton
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter,
                                    },
                                    color: theme.palette.primary.main,
                                  }}
                                  color='inherit'
                                  size='small'
                                >
                                  <Visibility fontSize='small' />
                                </IconButton>
                              </Link>
                            </Tooltip>
                            <Tooltip title='Delete money receipt' arrow>
                              <IconButton
                                onClick={() => {
                                  setDeleteId(details.id);
                                  setOpen2(true);
                                }}
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.error.lighter,
                                  },
                                  color: theme.palette.error.main,
                                }}
                                color='inherit'
                                size='small'
                              >
                                <DeleteTwoToneIcon fontSize='small' />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title='Transfer money receipt' arrow>
                              <IconButton
                                onClick={() => {
                                  setOpen1(true);

                                  setMoneyReceiptId(details.id);
                                }}
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.error.lighter,
                                  },
                                  color: theme.palette.primary.main,
                                }}
                                color='inherit'
                                size='small'
                              >
                                <MoveUpIcon fontSize='small' />
                              </IconButton>
                            </Tooltip>
                            <DeleteConfirmation
                              open={open2}
                              handleClose={() => {
                                setOpen2(false);
                                setDeleteId(null);
                              }}
                              text='Want to delete this money receipt?'
                              handleDeleteFun={() => {
                                if (deleteId) handleDelete(deleteId);
                              }}
                              loading={isDeleteLoading}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <>
                      <TableNotFound />
                    </>
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </>

      <Box display={'none'}>
        <PrintMoneyReceipt
          componentRef={componentRef}
          memberInvoice={memberInvoice}
          companyName={companyName}
          date={dateRange}
        />
      </Box>

      <ModalsWrapper
        modalData={{ title: 'Transfer Money Receipt' }}
        setShowModal={setOpen1}
        showModal={open1}
      >
        <TransferMoneyReceipt
          handleClose={setOpen1}
          setRefresh={setRefresh}
          moneyReceiptId={moneyReceiptId}
        />
      </ModalsWrapper>
      <ModalsWrapper
        modalData={{ title: 'Create Money Receipt' }}
        setShowModal={setOpen}
        showModal={open}
      >
        <CreateOldMoneyReceipt handleClose={setOpen} setRefresh={setRefresh} />
      </ModalsWrapper>
    </Box>
  );
};

export default CompanyOldMoneyReceipt;
